import { Link } from "react-router-dom";
import moment from "moment";
import SectionTitle from "./SectionTitle";
import Moment from "react-moment";

// A distinct flag per item type so the invoice reads at a glance: the base
// fare, an edit fee, an extra charge, or a cancellation fee.
const ITEM_TYPE_BADGES = {
  booking: { label: "Booking", className: "tw:bg-[#E6F6EC] tw:text-[#34A853]" },
  bookingeditfee: { label: "Booking Edit Fee", className: "tw:bg-[#FFFAF0] tw:text-[#F2AE09]" },
  additionalfee: { label: "Additional Fee", className: "tw:bg-[#EAF2FB] tw:text-[#4A7FB5]" },
  cancelfee: { label: "Cancel Fee", className: "tw:bg-[#FDECEA] tw:text-[#EA4335]" },
};

const TypeBadge = ({ type }) => {
  const meta = ITEM_TYPE_BADGES[type] || {
    label: type,
    className: "tw:bg-[#F3F3F3] tw:text-[#7C7B7B]",
  };
  return (
    <span
      className={`tw:inline-flex tw:h-[28px] tw:items-center tw:justify-center tw:whitespace-nowrap tw:rounded-[5px] tw:px-3 tw:text-[13px] tw:font-[600] tw:leading-[20px] ${meta.className}`}
    >
      {meta.label}
    </span>
  );
};

const COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[50px] tw:rounded-tl-[5px]" },
  { key: "type", title: "Type", width: "tw:w-[160px]" },
  { key: "booking", title: "Ref", width: "tw:w-[130px]" },
  { key: "travelDate", title: "Travel Date", width: "tw:w-[180px]" },
  { key: "pickup", title: "Pickup", width: "tw:w-[260px]" },
  { key: "amount", title: "Amount", width: "tw:w-[160px]" },
  { key: "addedAt", title: "Added At", width: "tw:w-[180px] tw:rounded-tr-[5px]" },
];

const headerCellClass =
  "tw:h-[52px] tw:bg-[#282828] tw:px-[15px] tw:text-left tw:text-[14px] tw:font-bold tw:leading-[20px] tw:text-white tw:whitespace-nowrap";

const bodyCellClass =
  "tw:h-[60px] tw:border-b tw:border-[#F3F3F3] tw:bg-white tw:px-[15px] tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:align-middle";

const footCellClass =
  "tw:h-[56px] tw:bg-[#F9F9F9] tw:px-[15px] tw:text-[15px] tw:leading-[22px] tw:font-bold tw:text-[#282828] tw:align-middle";

const getLocationDetail = (loc) => {
  const formattedAddressArr = loc?.formatted_address?.split(",");
  const name = formattedAddressArr?.[0];
  const address = formattedAddressArr?.slice(1).join(",");
  return { name, address };
};

const InvoiceItemsDetail = ({ items = [] }) => {
  const totalAmount = items.reduce((sum, item) => sum + (item.amount || 0), 0);

  return (
    <>
      {/* <SectionTitle title="Invoice Items" /> */}
      <div className="tw:mb-5 tw:overflow-hidden tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white">
        <div className="tw:w-full tw:overflow-x-auto">
          <table className="tw:w-full tw:min-w-[1000px] tw:border-separate tw:border-spacing-0">
            <thead>
              <tr>
                {COLUMNS.map((column) => (
                  <th key={column.key} className={`${headerCellClass} ${column.width}`}>
                    {column.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td
                    colSpan={COLUMNS.length}
                    className={`${bodyCellClass} tw:text-center tw:text-[#7C7B7B]`}
                  >
                    No items in this invoice
                  </td>
                </tr>
              ) : (
                items.map((item, i) => {
                  const booking = item.booking;
                  const bookingLinkId = booking?._id;
                  return (
                    <tr key={item._id || i}>
                      <td className={bodyCellClass}>{i + 1}</td>
                      <td className={bodyCellClass}>
                        <TypeBadge type={item.type} />
                      </td>
                      <td className={bodyCellClass}>
                        {bookingLinkId ? (
                          <Link
                            to={`/admin/bookinglist/edit/v2/${bookingLinkId}`}
                            className="tw:text-[#4A7FB5] tw:no-underline hover:tw:underline"
                          >
                            {`#${booking.key || bookingLinkId}`}
                          </Link>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className={`${bodyCellClass} tw:whitespace-nowrap`}>
                        <Moment format="YYYY/MM/DD hh:mm A">{booking?.pickupDateTime ? booking?.pickupDateTime : "-"}</Moment>
                        {/* {booking?.pickupDateTime
                          ? moment.utc(booking.pickupDateTime).format("YYYY/MM/DD HH:mm")
                          : "-"} */}
                      </td>
                      <td className={bodyCellClass}>
                        <div className="tw:flex tw:flex-col">
                          <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">
                            {getLocationDetail(booking?.pickupLocation).name}
                          </span>
                          <span className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none tw:block tw:max-w-[250px] tw:truncate tw:whitespace-nowrap">
                            {getLocationDetail(booking?.pickupLocation).address}
                          </span>
                        </div>
                        {/* {booking?.pickupLocation?.label || "-"} */}
                      </td>
                      <td className={`${bodyCellClass} tw:whitespace-nowrap`}>
                        {(item.amount || 0).toLocaleString()} JPY
                      </td>
                      <td className={`${bodyCellClass} tw:whitespace-nowrap`}>
                        <Moment format="YYYY/MM/DD hh:mm A">{item.addedAt ? item.addedAt : "-"}</Moment>
                        {/* {item.addedAt ? moment(item.addedAt).format("YYYY/MM/DD HH:mm") : "-"} */}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
            {items.length > 0 && (
              <tfoot>
                <tr>
                  <td colSpan={5} className={`${footCellClass} tw:text-right`}>
                    Total
                  </td>
                  <td className={`${footCellClass} tw:whitespace-nowrap`}>
                    {totalAmount.toLocaleString()} JPY
                  </td>
                  <td className={footCellClass} />
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default InvoiceItemsDetail;
